import * as React from 'react'

export const useScrollToTop = (
  opts: {
    behavior?: ScrollBehavior
    disableOnMount?: boolean
  } = {}
) => {
  const { behavior = 'auto', disableOnMount = false } = opts
  const scrollToTop = React.useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior
    })
    // behaviour should be set only once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
    !disableOnMount && scrollToTop()
    // only relevant on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollToTop])

  return { scrollToTop }
}
